import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-admin",
  "use": "icon-admin-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-admin\">\r\n<path d=\"M18.3346 9.99996C18.3346 14.6023 14.6037 18.3333 10.0013 18.3333C5.39893 18.3333 1.66797 14.6023 1.66797 9.99996C1.66797 5.39759 5.39893 1.66663 10.0013 1.66663C14.6037 1.66663 18.3346 5.39759 18.3346 9.99996Z\" stroke=\"#64748B\" stroke-width=\"1.5\" />\r\n<path d=\"M12.2923 7.91667C12.2923 9.18232 11.2663 10.2083 10.0007 10.2083C8.735 10.2083 7.70898 9.18232 7.70898 7.91667C7.70898 6.65101 8.735 5.625 10.0007 5.625C11.2663 5.625 12.2923 6.65101 12.2923 7.91667Z\" stroke=\"#64748B\" stroke-width=\"1.5\" />\r\n<path d=\"M4.58398 15.8334L5.05098 15.0162C5.79283 13.7179 7.17342 12.9167 8.66866 12.9167H11.3326C12.8279 12.9167 14.2085 13.7179 14.9503 15.0162L15.4173 15.8334\" stroke=\"#64748B\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/admin.svg
// module id = BlLF
// module chunks = 36